export default "__VITE_ASSET__CGmSgckd__"